import { useCallback } from 'react';
import { uniqueId } from 'js/utils/methods.util';

import * as Types from './types';
import { TServerSendResponse } from '../../types';
import { useGenericSend } from '../useGenericSend';
import { IGNORE_LIMITS_NOTIFICATION } from '../../constants';

export const useSetDepositLimits = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.ISetDepositLimitsRequestData): Promise<TServerSendResponse> => {
        const { data } = await send<Types.ISetDepositLimitsRequestData, TServerSendResponse>({
            ID: 89904,
            responses: [89908, 89900],
            description: 'Set deposit limits',
            errorLevel: 1,
            correlationId: uniqueId(`${IGNORE_LIMITS_NOTIFICATION}-`),
            ...request
        });

        return data;
    }, [
        send
    ]);
};
